import React, { useContext, useState, useEffect, useRef } from 'react'

import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import CommonContext from '@/product/context/common/commonContext'
import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/product/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import SettingCustomContext from '@/custom/context/setting/settingContext'
import moment from 'moment'

const CurrencyManage = (props) => {
    // const settingcontext = useContext(SettingContext)
    const usercommoncontext = useContext(UserCommonContext)
    const commonContext = useContext(CommonContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const { USStates, allCountries, allStates, allCounties, getAllCounties } =
        commonContext

    const { allLocations, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(true)
    const settingCustomContext = useContext(SettingCustomContext)

    const {
        searchTableAction,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingCustomContext

    const { getPreviousData, clearPreviousData, previous_data } =
        usercommoncontext
    const [parkingSlot, setParkingSlot] = useState([])
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const data = props.data
    const toggleFullScreenPopup = props.function

    const validationArray = Yup.object({
        current_value: Yup.string().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            current_value: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            values.table = 'currency_values'
            // values.uniqueValue = values.factory_code
            searchTableAction(values, false, 'currency_create')
        },
    })

    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'currency_create' &&
                responseStatusSetting.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                formik.resetForm()
            }
        }
    }, [responseStatusSetting])

    useEffect(() => {
        if (data.status != 'new') {
            formik.setFieldValue('id', data.id)
            const template =
                props?.record?.find((cat) => cat.id === data.id) || {}

            formik.setValues({
                ...formik.values,
                ...template,
            })
        } else {
            resetFrom()
        }
    }, [data])

    const resetFrom = () => {
        formik.setValues({
            id: 0,
            current_value: '',

            // where: 'factory_code',
        })
    }

    const details = {
        formik: formik,
        data: [
            {
                label: 'Currecny Value',
                placeholder: 'EnterCurrecny Value',
                type: 'number',
                required: true,
                class: 'col-6',
                name: 'current_value',
            },
        ],
    }

    const submitFunction = () => {
        formik.handleSubmit()
        //toggleFullScreenPopup(false)
    }
    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? 'Add New Currecny'
                    : data.status === 'edit'
                    ? 'Edit Currency Value'
                    : 'Edit Currency Value'
            }
            open={data.popup}
            handleClose={() => {
                toggleFullScreenPopup(false, 'new', 0)
                formik.resetForm()
            }}
        >
            <div className="dashboard addNewListing mt-4">
                <div className="fspBody">
                    <div className="row">{mapData(details)}</div>

                    <div className="actionButton d-flex justify-content-center align-items-center">
                        <SecondaryButton
                            id="location_cancel"
                            label="Cancel"
                            onClick={() => {
                                toggleFullScreenPopup(false)
                                formik.resetForm()
                            }}
                        />
                        <PrimaryButton
                            id="location_submit"
                            label="Submit"
                            onClick={submitFunction}
                        />
                    </div>
                    {/* </form> */}
                </div>
            </div>
        </FullScreenPopup>
    )
}
export default CurrencyManage
